import { Accordion } from '@chakra-ui/react';
import PTORequestItem from '@/components/PTORequestItem';
import { Filter } from '@/pages/PTORequests/PTORequests.component';
import { EmptyState } from '@/pages/PTORequests/PTORequests.styles';
import { trioUITheme } from '@/styles/theme';
import { PTORequest } from '@/types/api';

type PTORequestsListComponentProps = {
  ptoRequestList: PTORequest[];
  onUpdate?: () => void;
  filter: Filter;
};
const PTORequestsListComponent = function ({
  ptoRequestList,
  onUpdate,
  filter,
}: PTORequestsListComponentProps): JSX.Element {
  return ptoRequestList.length === 0 ? (
    <EmptyState
      title={
        filter === 'All'
          ? 'There’s no PTO requests yet'
          : 'Congrats! 🎉\nThere’s no unanswered requests remaining'
      }
      description={
        filter === 'All'
          ? 'All requests will appear here once they start to be made.'
          : 'You can always see All Requests and PTO Schedule by navigating through the tabs above.'
      }
    />
  ) : (
    <Accordion
      allowMultiple
      border="1px"
      borderStyle="solid"
      borderColor={trioUITheme.colors['neutral-40']}
      borderRadius="8px"
      data-testid="pto-requests-list"
      style={{ overflow: 'hidden' }}
    >
      {ptoRequestList.map((ptoRequest) => (
        <PTORequestItem key={ptoRequest.id} ptoRequest={ptoRequest} onUpdateRequest={onUpdate} />
      ))}
    </Accordion>
  );
};

export default PTORequestsListComponent;
